import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './FreelanceInterviewConfirmInfoForm.jsx'

export default createSubmit(name)
